// extracted by mini-css-extract-plugin
export default {"withNotify":"style_withNotify__NjrzF"};